export const isFetching = state => state.dashboards.fetching;
export const dashboards = state => state.dashboards.dashboards;
export const error = state => state.dashboards.error;
export const dashboardsByType = (state, type) =>
  state.dashboards.dashboards[type] || {};
